import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as GroupActions from '../../actions/group';
import * as UserActions from '../../actions/users';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { RootState } from '../../reducers';
import { GroupData } from '../../models/Group';
import { UserData } from '../../models/User';
import * as Modal from 'react-modal';
import PermissionEdit from './permissionedit';
import { Popup } from '../Common/popup';
import { Header } from '../Common/header';
import { RedBox } from '../Common/redBox';

export namespace Groups {
	export interface Props extends RouteComponentProps<void> {
		groupActions: typeof GroupActions;
		userActions: typeof UserActions;
		groups: GroupData[];
		user: UserData;
		modalOpen: boolean;
	}

	export interface State {
		modalState: string;
		selectedGroup: string;
	}
}

const MODAL_STATE = {
	NONE: '',
	ADD_GROUP: 'ADD_GROUP',
	EDIT_PERMISSIONS: 'EDIT_PERMISSIONS'
}

@connect(mapStateToProps, mapDispatchToProps)
export default class Groups extends React.Component<Groups.Props, Groups.State> {

	static contextTypes = {
		router: PropTypes.func.isRequired
	};

	constructor(props: Groups.Props) {
		super(props);

		this.state = {
			modalState: MODAL_STATE.NONE,
			selectedGroup: null
		};

		this.openAddGroupModal = this.openAddGroupModal.bind(this);
		this.openEditPermissionsModal = this.openEditPermissionsModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.addGroup = this.addGroup.bind(this);
		this.updatePermissions = this.updatePermissions.bind(this);
	}

	addGroup(values: any) {
		const {groupActions, user} = this.props;

		const groupData: GroupData = {
			_id: "" + (Date.now() + Math.floor(Math.random() * 1000)),
			name: values.name,
			students: [],
			campaigns: [],
			owners: [user._id]
		};
		groupActions.addGroup(groupData);
		this.closeModal();
	}

	updatePermissions(id: string, users: string[]) {
		const { groups, groupActions } = this.props;
		const group = groups.find((element) => element._id === id);
		group.owners = users;
		groupActions.updatePermissions(group);
		this.setState({modalState: MODAL_STATE.NONE})
	}

	deleteGroup(id: string) {
		const {groupActions} = this.props;
		const group = this.props.groups.find((element) => element._id === id);
		groupActions.deleteGroup(group);
	}

	openAddGroupModal(e: any){
		e.preventDefault();
		this.setState({modalState: MODAL_STATE.ADD_GROUP});
	}

	openEditPermissionsModal(e:any, id: string){
		e.preventDefault();
		this.setState({modalState: MODAL_STATE.EDIT_PERMISSIONS, selectedGroup: id});
	}

	closeModal(e?: any) {
		if (e) e.preventDefault();
		this.setState({modalState: MODAL_STATE.NONE});
	}

	render() {
		const {groups, user} = this.props;
		const {modalState, selectedGroup} = this.state;

		let groupElements = [];
		let popupelement;

		if(modalState === MODAL_STATE.ADD_GROUP){
			popupelement = (
				<div>
					<h4>Anna uudelle opetusryhmälle nimi</h4>
					<Popup.Form
						inputs={[{name: "name", type: "text", placeholder: "nimi"}]}
						buttons={[{text: "TALLENNA RYHMÄ", image: "images/GreenPlusButton.png"}]}
						accept={this.addGroup}
					/>
				</div>
			);
		}else if(modalState === MODAL_STATE.EDIT_PERMISSIONS) {
			popupelement = (
				<div>
					<PermissionEdit allowedUsers={groups.find((g) => g._id === selectedGroup).owners} editAllowedUsers={(users: string[]) => this.updatePermissions(selectedGroup, users)} />
				</div>
			);
		}

		for(let group of groups){
			groupElements.push(this.getGroupElement(group));
		}

		return (
			<div className="am_widecontainer">
				<div className="margin5">
					<Header user={user} userActions={this.props.userActions}/>
				</div>
				<div className="am_teachercontainer">
					<h4><b>Opetusryhmät</b></h4>
					<div className="am_innercontainer am_groupcontainer">
						{groupElements}
					</div>
					<button onClick={this.openAddGroupModal} className="btn am_green-button am_shadow mt-3 p-3"><img src="images/GreenPlusButton.png" className="am_smallicon"/>LISÄÄ UUSI RYHMÄ...</button>
				</div>
				<Modal isOpen={this.state.modalState !== MODAL_STATE.NONE} contentLabel="Minimal Modal Example" style={Popup.modalStyle}>
					<Popup.Element element={popupelement} closeModal={this.closeModal}/>
				</Modal>
			</div>
		);
	}

	getGroupElement(group: GroupData){
		return(
			<div className="row mb-2">
					<div className="col-1 am_group_aligner">
						<div className='am_group_aligner-item'>
							{group.name}
						</div>
					</div>
					<div className="col-3">	
						<Link to={"/evaluation/"+group._id}>
							<button title="arviointiin" className="btn am_green-button am_shadow col-12"><img src="images/LibrayGem.png" className="am_smallicon"/>ARVIOINTIIN</button>
						</Link>
					</div>
					<div className="col-8">
					<div className="float-right">
						<Link to={"/groupsettings/"+group._id}>
							<button title="muokkaa ryhmää" className="btn am_gray-button am_shadow am_buttonsmalltext mr-2"><img src="images/SettingGear.png" className="am_smallicon"/>MUOKKAA RYHMÄÄ</button>
						</Link>
						<button onClick={(e)=>this.openEditPermissionsModal(e, group._id)} title="muuta ryhmän yhteishallinnointia" className="btn am_blue-button am_shadow am_buttonsmalltext mr-2"><img src="images/ManyPeople.png" className="am_smallicon"/>MUUTA RYHMÄN YHTEISHALLINNOINTIA</button>
						<button onClick={()=>this.deleteGroup(group._id)} title="poista" className="btn am_darkblue-button am_shadow align-middle am_buttonsmalltext"><img src="images/CrossButton.png" className="am_smallicon"/>POISTA</button>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state: RootState) {
	return {
		groups: state.groups,
		user: state.user
	};
}

function mapDispatchToProps(dispatch: Dispatch<Function>) {
	return {
		groupActions: bindActionCreators(GroupActions as {}, dispatch),
		userActions: bindActionCreators(UserActions as {}, dispatch)
	};
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/Groups/index.tsx